{
  "publicationDate": "2026-03-13",
  "verified": "2026-09-12",
  "years": [
    2021,
    2022,
    2023,
    2024,
    2025
  ],
  "tables": {
    "18": {
      "url": "https://www.bls.gov/news.release/jolts.t18.htm",
      "title": "Table 18. Annual average hires rates by industry and region, not seasonally adjusted",
      "rows": [
        {
          "label": "Total",
          "values": [
            4.3,
            4.2,
            3.8,
            3.4,
            3.3
          ]
        },
        {
          "label": "Total private",
          "values": [
            4.8,
            4.6,
            4.1,
            3.7,
            3.6
          ]
        },
        {
          "label": "Manufacturing",
          "values": [
            3.6,
            3.6,
            3.1,
            2.6,
            2.4
          ]
        },
        {
          "label": "Wholesale trade",
          "values": [
            3.1,
            3.1,
            2.7,
            2.3,
            2.2
          ]
        },
        {
          "label": "Retail trade",
          "values": [
            5.6,
            5,
            4.5,
            4,
            3.7
          ]
        },
        {
          "label": "Information",
          "values": [
            3.9,
            3.5,
            2.4,
            2.6,
            2.6
          ]
        },
        {
          "label": "Finance and insurance",
          "values": [
            2.3,
            2.4,
            1.8,
            1.9,
            2.1
          ]
        },
        {
          "label": "Real estate and rental and leasing",
          "values": [
            3.4,
            3.5,
            3.1,
            2.8,
            2.6
          ]
        },
        {
          "label": "Professional and business services",
          "values": [
            5.9,
            5.5,
            4.6,
            4.4,
            4.6
          ]
        },
        {
          "label": "Private educational services",
          "values": [
            2.9,
            2.6,
            2.6,
            2.4,
            2.2
          ]
        },
        {
          "label": "Health care and social assistance",
          "values": [
            3.4,
            3.7,
            3.7,
            3.4,
            3.1
          ]
        },
        {
          "label": "Arts, entertainment, and recreation",
          "values": [
            8.3,
            7.3,
            6.7,
            6.3,
            6.3
          ]
        },
        {
          "label": "Accommodation and food services",
          "values": [
            8.5,
            7.5,
            6.5,
            5.5,
            5.5
          ]
        },
        {
          "label": "Other services",
          "values": [
            4.2,
            3.9,
            3.7,
            3.7,
            3.4
          ]
        },
        {
          "label": "Northeast",
          "values": [
            3.7,
            3.5,
            3.2,
            3,
            3
          ]
        },
        {
          "label": "South",
          "values": [
            4.7,
            4.7,
            4.3,
            3.7,
            3.4
          ]
        },
        {
          "label": "Midwest",
          "values": [
            4.4,
            4.1,
            3.7,
            3.4,
            3.5
          ]
        },
        {
          "label": "West",
          "values": [
            4.2,
            4.1,
            3.4,
            3.2,
            3.2
          ]
        }
      ]
    },
    "20": {
      "url": "https://www.bls.gov/news.release/jolts.t20.htm",
      "title": "Table 20. Annual average total separations rates by industry and region, not seasonally adjusted",
      "rows": [
        {
          "label": "Total",
          "values": [
            3.9,
            3.9,
            3.6,
            3.3,
            3.3
          ]
        },
        {
          "label": "Total private",
          "values": [
            4.4,
            4.3,
            4,
            3.7,
            3.6
          ]
        },
        {
          "label": "Manufacturing",
          "values": [
            3.4,
            3.3,
            3.1,
            2.7,
            2.4
          ]
        },
        {
          "label": "Wholesale trade",
          "values": [
            2.8,
            2.7,
            2.6,
            2.4,
            2.3
          ]
        },
        {
          "label": "Retail trade",
          "values": [
            5.4,
            5,
            4.5,
            4,
            3.8
          ]
        },
        {
          "label": "Information",
          "values": [
            3.1,
            3.1,
            2.8,
            2.8,
            2.8
          ]
        },
        {
          "label": "Finance and insurance",
          "values": [
            2.2,
            2.3,
            1.9,
            1.9,
            2.1
          ]
        },
        {
          "label": "Real estate and rental and leasing",
          "values": [
            3,
            3.2,
            3,
            2.9,
            2.6
          ]
        },
        {
          "label": "Professional and business services",
          "values": [
            5.4,
            5.3,
            4.6,
            4.4,
            4.6
          ]
        },
        {
          "label": "Private educational services",
          "values": [
            2.1,
            2.5,
            2.3,
            2.2,
            2.2
          ]
        },
        {
          "label": "Health care and social assistance",
          "values": [
            3.3,
            3.4,
            3.3,
            3,
            2.9
          ]
        },
        {
          "label": "Arts, entertainment, and recreation",
          "values": [
            6.6,
            6.3,
            6.2,
            6.1,
            6.1
          ]
        },
        {
          "label": "Accommodation and food services",
          "values": [
            7.1,
            7,
            6.3,
            5.4,
            5.5
          ]
        },
        {
          "label": "Other services",
          "values": [
            3.7,
            3.7,
            3.4,
            3.6,
            3.3
          ]
        },
        {
          "label": "Northeast",
          "values": [
            3.2,
            3.2,
            3,
            3,
            3
          ]
        },
        {
          "label": "South",
          "values": [
            4.3,
            4.4,
            4.1,
            3.5,
            3.4
          ]
        },
        {
          "label": "Midwest",
          "values": [
            4,
            3.8,
            3.6,
            3.4,
            3.5
          ]
        },
        {
          "label": "West",
          "values": [
            3.8,
            3.9,
            3.4,
            3.3,
            3.3
          ]
        }
      ]
    },
    "22": {
      "url": "https://www.bls.gov/news.release/jolts.t22.htm",
      "title": "Table 22. Annual average quits rates by industry and region, not seasonally adjusted",
      "rows": [
        {
          "label": "Total",
          "values": [
            2.7,
            2.8,
            2.4,
            2.1,
            2
          ]
        },
        {
          "label": "Total private",
          "values": [
            3,
            3.1,
            2.6,
            2.3,
            2.2
          ]
        },
        {
          "label": "Manufacturing",
          "values": [
            2.4,
            2.3,
            2,
            1.6,
            1.4
          ]
        },
        {
          "label": "Wholesale trade",
          "values": [
            1.9,
            1.7,
            1.6,
            1.4,
            1.4
          ]
        },
        {
          "label": "Retail trade",
          "values": [
            4.2,
            3.9,
            3.3,
            2.7,
            2.6
          ]
        },
        {
          "label": "Information",
          "values": [
            1.8,
            1.7,
            1.4,
            1.5,
            1.3
          ]
        },
        {
          "label": "Finance and insurance",
          "values": [
            1.3,
            1.5,
            1.2,
            1.1,
            1.3
          ]
        },
        {
          "label": "Real estate and rental and leasing",
          "values": [
            2,
            2.2,
            1.9,
            1.6,
            1.6
          ]
        },
        {
          "label": "Professional and business services",
          "values": [
            3.4,
            3.3,
            2.6,
            2.4,
            2.3
          ]
        },
        {
          "label": "Private educational services",
          "values": [
            1.4,
            1.6,
            1.4,
            1.3,
            1.4
          ]
        },
        {
          "label": "Health care and social assistance",
          "values": [
            2.5,
            2.6,
            2.4,
            2.2,
            2
          ]
        },
        {
          "label": "Arts, entertainment, and recreation",
          "values": [
            3.5,
            3.3,
            3.3,
            2.8,
            2.2
          ]
        },
        {
          "label": "Accommodation and food services",
          "values": [
            5.8,
            5.8,
            5,
            4.1,
            4.2
          ]
        },
        {
          "label": "Other services",
          "values": [
            2.3,
            2.5,
            2.1,
            2.5,
            2.2
          ]
        },
        {
          "label": "Northeast",
          "values": [
            2,
            2.1,
            1.8,
            1.7,
            1.6
          ]
        },
        {
          "label": "South",
          "values": [
            3.1,
            3.2,
            2.8,
            2.3,
            2.2
          ]
        },
        {
          "label": "Midwest",
          "values": [
            2.8,
            2.6,
            2.3,
            2.1,
            2.2
          ]
        },
        {
          "label": "West",
          "values": [
            2.6,
            2.7,
            2.2,
            2,
            1.9
          ]
        }
      ]
    },
    "24": {
      "url": "https://www.bls.gov/news.release/jolts.t24.htm",
      "title": "Table 24. Annual average layoffs and discharges rates by industry and region, not seasonally adjusted",
      "rows": [
        {
          "label": "Total",
          "values": [
            1,
            1,
            1.1,
            1.1,
            1.1
          ]
        },
        {
          "label": "Total private",
          "values": [
            1.1,
            1.1,
            1.2,
            1.2,
            1.2
          ]
        },
        {
          "label": "Manufacturing",
          "values": [
            0.8,
            0.8,
            0.9,
            0.9,
            0.9
          ]
        },
        {
          "label": "Wholesale trade",
          "values": [
            0.7,
            0.8,
            0.8,
            0.8,
            0.8
          ]
        },
        {
          "label": "Retail trade",
          "values": [
            1,
            0.9,
            1,
            1.1,
            1.1
          ]
        },
        {
          "label": "Information",
          "values": [
            1,
            1.2,
            1.1,
            1.1,
            1.3
          ]
        },
        {
          "label": "Finance and insurance",
          "values": [
            0.4,
            0.5,
            0.4,
            0.5,
            0.6
          ]
        },
        {
          "label": "Real estate and rental and leasing",
          "values": [
            0.8,
            0.8,
            0.9,
            1.1,
            0.9
          ]
        },
        {
          "label": "Professional and business services",
          "values": [
            1.7,
            1.6,
            1.7,
            1.8,
            2
          ]
        },
        {
          "label": "Private educational services",
          "values": [
            0.6,
            0.7,
            0.7,
            0.8,
            0.7
          ]
        },
        {
          "label": "Health care and social assistance",
          "values": [
            0.6,
            0.6,
            0.7,
            0.7,
            0.7
          ]
        },
        {
          "label": "Arts, entertainment, and recreation",
          "values": [
            2.9,
            3,
            2.8,
            3.2,
            3.8
          ]
        },
        {
          "label": "Accommodation and food services",
          "values": [
            1.1,
            1,
            1.2,
            1.1,
            1.1
          ]
        },
        {
          "label": "Other services",
          "values": [
            1.2,
            1,
            1.1,
            0.9,
            1
          ]
        },
        {
          "label": "Northeast",
          "values": [
            1,
            0.9,
            1,
            1.1,
            1.2
          ]
        },
        {
          "label": "South",
          "values": [
            1,
            1,
            1.1,
            1,
            1
          ]
        },
        {
          "label": "Midwest",
          "values": [
            1,
            1,
            1.1,
            1.1,
            1.2
          ]
        },
        {
          "label": "West",
          "values": [
            0.9,
            1,
            1,
            1.1,
            1.2
          ]
        }
      ]
    }
  }
}
